import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { INotificationsSettingsRow } from '../types';
import React, { useMemo } from 'react';
import Table from '../../../../components/Table';
import { AdminNotificationDestinationType as EventDestination } from '../../../../utils/apollo/graphqlSchema';
import { NOTIFICATIONS_TABLE_CONFIG } from './notificationsTableStyles';
import useDestinationColumn from '../hooks/useDestinationColumn';

interface IProps {
  header: string;
  data: INotificationsSettingsRow[];
}

const NotificationsSettingsTable = ({ data, header }: IProps) => {
  const columnHelper = createColumnHelper<INotificationsSettingsRow>();

  const { destinationColumnAccessor } = useDestinationColumn();

  const columns = useMemo(
    () => [
      columnHelper.accessor('eventDescription', {
        id: 'eventDescription',
        header,
        meta: NOTIFICATIONS_TABLE_CONFIG.eventDescription,
      }),
      destinationColumnAccessor({
        destination: EventDestination.Email,
        header: 'Email',
        meta: NOTIFICATIONS_TABLE_CONFIG.email,
      }),
      destinationColumnAccessor({
        destination: EventDestination.Slack,
        header: 'Slack',
        meta: NOTIFICATIONS_TABLE_CONFIG.slack,
      }),
    ],
    [columnHelper, destinationColumnAccessor, header],
  );
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Table
      headerGroups={table.getHeaderGroups()}
      rows={table.getRowModel().rows}
    />
  );
};

export default NotificationsSettingsTable;
